import styled from 'styled-components';

const Select = styled.select`
    height: 43px;
    width: 266px;
    padding-left: 5px;
    border-radius: 0px;
    background-color: #FFFFFF;
    width: 100%;
    margin-top: 5px;
    margin-bottom: 10px;
    text-transform: uppercase;
    color: ${props => props.theme.colors.darkgray};
    font-family: 'Lato', sans-serif;
    font-size: 1em;
    line-height: 32px;
    border: 0;
    outline: 1px solid ${props => props.theme.colors.darkgray};
    background-color: white;
    align-self: flex-end;
`;

export default Select;



// WEBPACK FOOTER //
// ./src/components/atoms/inputs/Select.js